// actions
import {
  ROUTEBTN_UPDATE_LABEL,
  ROUTEBTN_UPDATE_CLASS,
  ROUTEBTN_UPDATE_ALL,
} from './actions';

const RouteBtn = (state = {
  label: '',
  className: '',
}, action) => {
  switch (action.type) {
    case ROUTEBTN_UPDATE_LABEL:
      return {
        ...state,
        label: action.label,
      };
    case ROUTEBTN_UPDATE_CLASS:
      return {
        ...state,
        className: action.className,
      };
    case ROUTEBTN_UPDATE_ALL:
      return {
        ...state,
        label: action.data.label,
        className: action.data.className,
      };
    default:
      return state;
  }
};

export default RouteBtn;
